import type { CommercialDocumentExport } from "../../shared/commercial-documents";
import { commercialDocumentFilename } from "../../shared/commercial-document-layout";

export async function downloadCommercialDocument(record: CommercialDocumentExport) {
  const { buildCommercialPdf } = await import("../../shared/commercial-document-pdf");
  const bytes = await buildCommercialPdf(record);
  const url = URL.createObjectURL(new Blob([new Uint8Array(bytes)], { type: "application/pdf" }));
  const link = document.createElement("a");
  link.href = url;
  link.download = commercialDocumentFilename(record.document, record.revision);
  document.body.append(link);
  link.click();
  link.remove();
  // Browsers may consume the download asynchronously after the click.
  setTimeout(() => {
    URL.revokeObjectURL(url);
  }, 1000);
}
